import React from 'react'
import { withAppContext } from 'src/store/initAppContext';
import { withTheme } from 'styled-components';
import { getDamain } from 'src/util/commonfun';
import AviatrixSEO31 from './AviatrixSEO31';
import AviatrixSEO39 from './AviatrixSEO39';

const AviatrixSEO = (props: any) => {
  const { app: { brandId } } = props;

  let domainURL = getDamain(brandId)

  return (
    (brandId === 40 || brandId === 46 || brandId === 47) ? <></> :
    (brandId === 31) ? <AviatrixSEO31 /> :
    (brandId === 39) ? <AviatrixSEO39 /> :
    <AviatrixSEO31 />
  )
}

export default withTheme(withAppContext(AviatrixSEO));